<script setup>
import {useFormField} from "../../../Registration/composables/useFormField";
import {useProcessedOptions} from "../../../Registration/composables/useProcessedOptions";
import FieldErrorMessage from "../../../Registration/components/Fields/FieldErrorMessage.vue";
import {computed} from "vue";

const emit = defineEmits(['blur', 'input']);

const {item, group, groupId, backend} = defineProps(['item', 'group', 'groupId', 'backend']);
const {model, uniqueItemId, options, path, isReadOnly, getFieldClasses, getPrefix, createBlurHandler, createInputHandler} = useFormField(item, group, groupId, (v) => v, (v) => v, backend);
const {processedOptions} = useProcessedOptions(item, options, getPrefix, isReadOnly, model, group, groupId);

const handleBlur = createBlurHandler(emit);
const handleInput = createInputHandler(emit);

const layout = item.data.layout ?? 'horizontal';

const colClass = computed(() => {
    if (layout === 'horizontal') {
        if (options.value?.length % 3 === 0) return 'grid-cols-3';
        if (options.value?.length % 2 === 0) return 'grid-cols-2';
        return 'grid-cols-1';
    }
    return 'grid-cols-1';
});

const className = getFieldClasses('w-full form-group form-wrapper radio-field');

const handleClick = (event) => {
    if (isReadOnly.value) {
        event.preventDefault();
        return false;
    }
};
</script>

<template>
    <div :class="className">
        <div v-if="item.label !== null">
            <label class="field-label mr-2" :for="uniqueItemId">
                {{ item.label }}
                <span v-if="item.required && !isReadOnly"> *</span>
            </label>
        </div>
        <div :class="`grid lg:items-center gap-4 ${colClass} radio-items is-options-${layout}`">
            <div
                v-for="option in processedOptions"
                :key="option.key"
                :class="[
                    'mb-0 form-group radio-item',
                    { 'opacity-50! pointer-events-none': option.disabled }
                ]"
            >
                <label :for="`${uniqueItemId}-${option.key}`" class="mb-0 w-max max-w-full">
                    <input type="radio"
                           data-form-type="other"
                           v-model="model"
                           class="form-check-box"
                           :id="`${uniqueItemId}-${option.key}`"
                           :value="option.key"
                           :disabled="option.disabled"
                           @click="handleClick"
                           @blur="handleBlur"
                           @change="handleInput"/>
                    <span v-html="option.displayLabel" class="ml-2"></span>
                </label>
            </div>
        </div>
        <FieldErrorMessage :path="path" :backend="backend" />
    </div>
</template>

<style scoped>
.is-readonly .radio-item {
    opacity: 0.5;
    pointer-events: none;
}

.is-readonly input[type="radio"] {
    cursor: not-allowed;
}
</style>
